import './datadog';
import '@pysae/tokens/variables.css';

import { createApp } from 'vue';

import App from './App.vue';
import i18n from './i18n';
import router from './router';
import { initCapacitorPlugins } from '@/libs/capacitor';
import { initAppVisibility } from '@/libs/app-visibility';
import VueMatomoImport from 'vue-matomo';
import { v4 as uuid } from 'uuid';
import { Capacitor } from '@capacitor/core';
import { createPinia } from 'pinia';
import { vSafeHtml } from './directives/safe-html';

export const app = createApp(App);
const pinia = createPinia();
app.use(pinia);

// Vite 8 changed CJS interop: vue-matomo's UMD export is now wrapped as
// `{ default: install }`, so the default import is an object without an
// `install()` method. Left as-is, `app.use()` silently no-ops and ALL Matomo
// tracking stops (no _paq, matomo.js never loads). Unwrap to the real plugin.
// Stays correct if a future bump restores the plain-function default export.
const VueMatomo =
  (VueMatomoImport as unknown as { default?: typeof VueMatomoImport }).default ?? VueMatomoImport;

app.use(VueMatomo, {
  host: 'https://pysae.matomo.cloud',
  siteId: 5,
  userId: uuid(),
  // iOS (Safari ITP + embedded WKWebView) blocks the JS-set first-party cookies
  // `_pk_ses.*` / `_pk_id.*`, so the tracker raised "error setting cookie" on
  // every page view (100% of these errors came from iOS). Cookieless tracking
  // is Matomo's recommended mode for these contexts: visits are still counted
  // (reconstructed server-side via config_id) and no cookie write is attempted.
  disableCookies: true,
});
app.use(router);
app.use(i18n);
app.directive('safe-html', vSafeHtml);

initAppVisibility();
if (Capacitor.isNativePlatform()) {
  initCapacitorPlugins();
}

app.mount('#app');
